import requester from '@/lib/axios';
import { TrueOrFalseActivityElement } from '@/models/_deprecated/ActivityElement';

const baseUrl = 'true-or-false-activity';
const nestedUrl = (activityId: number) => `activities/${activityId}/${baseUrl}`;

/** @deprecated Use getTrueOrFalseQuestion from @/data/services/question/trueOrFalseQuestionServices */
export const getTrueOrFalseActivity = async (questionId: number) => {
  const { data: trueOrFalseActivity } =
    await requester().get<TrueOrFalseActivityElement>(
      `${baseUrl}/${questionId}/`,
    );
  return trueOrFalseActivity;
};

export const createTrueOrFalseQuestionIntoActivity = async (
  activityId: number,
  body: Partial<TrueOrFalseActivityElement>,
) => {
  const { data } = await requester().post<TrueOrFalseActivityElement>(
    `${nestedUrl(activityId)}/`,
    body,
  );
  return data;
};

export const updateTrueOrFalseQuestionIntoActivity = async (
  activityId: number,
  id: number,
  changes: Partial<Omit<TrueOrFalseActivityElement, 'id'>>,
) => {
  const { data } = await requester().patch<TrueOrFalseActivityElement>(
    `${nestedUrl(activityId)}/${id}/`,
    changes,
  );
  return data;
};
